module.exports = __webpack_public_path__ + "src/assets/img/密码.png";